// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qa-list li p{margin:1em 0;color:#333;line-height:30px}.qa-list li p span{font-size:14px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
